<template>
  <main class="gc-down">
    <section class="gc-down-panel">
      <div class="gc-down-mark" aria-hidden="true">
        <v-icon size="26" color="primary">mdi-store</v-icon>
      </div>

      <h1 class="gc-down-title">
        <span class="gc-down-host">{{ hostname }}</span>
        is currently unavailable.
      </h1>

      <p class="gc-down-copy">
        If you're a visitor to this website, please try again later.
      </p>

      <button type="button" class="gc-down-btn" @click="retry">Try again</button>

      <p class="gc-down-owner">
        If you're the owner of this website, please
        <a
          href="https://dashboard.growcify.com/signin"
          target="_blank"
          rel="noopener noreferrer"
          >sign in</a
        >
        to resolve the issue, or
        <a
          href="https://growcify.com"
          target="_blank"
          rel="noopener noreferrer"
          >contact support</a
        >.
      </p>
    </section>
  </main>
</template>

<script>
export default {
  name: "StoreInactive",

  created() {
    document.title = this.hostname + " is unavailable";
  },

  data() {
    return {
      hostname: window.location.hostname,
    };
  },

  methods: {
    retry() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.gc-down {
  min-height: 100dvh;
  display: grid;
  place-items: center;
  padding: 24px 16px;
  background: #f3f4f6;
  color: #1c2430;
}

.gc-down-panel {
  width: min(100%, 480px);
  background: #fff;
  border: 1px solid #e6e8ee;
  border-radius: 16px;
  padding: 36px 32px 28px;
}

.gc-down-mark {
  width: 52px;
  height: 52px;
  margin-bottom: 20px;
  display: grid;
  place-items: center;
  border-radius: 16px;
  background: #f3f4f6;
}

.gc-down-title {
  margin: 0 0 12px;
  font-size: 1.7rem;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 0;
  color: #1c2430;
}

.gc-down-host {
  color: var(--primary, #007bff);
  overflow-wrap: anywhere;
}

.gc-down-copy {
  margin: 0 0 24px;
  max-width: 36ch;
  font-size: 1rem;
  line-height: 1.5;
  color: #5c6570;
}

.gc-down-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 22px;
  border: 0;
  border-radius: 999px;
  background: #1c2430;
  color: #fff;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
}

.gc-down-btn:hover {
  background: #2a3444;
}

.gc-down-btn:active {
  transform: translateY(1px);
}

.gc-down-btn:focus-visible {
  outline: 2px solid var(--primary, #007bff);
  outline-offset: 3px;
}

.gc-down-owner {
  margin: 28px 0 0;
  padding-top: 20px;
  border-top: 1px solid #e6e8ee;
  font-size: 0.95rem;
  line-height: 1.55;
  color: #5c6570;
}

.gc-down-owner a {
  color: var(--primary, #007bff);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.gc-down-owner a:focus-visible {
  outline: 2px solid var(--primary, #007bff);
  outline-offset: 2px;
  border-radius: 4px;
}

@media (max-width: 599px) {
  .gc-down-panel {
    padding: 28px 20px 22px;
  }

  .gc-down-title {
    font-size: 1.45rem;
  }

  .gc-down-btn {
    width: 100%;
  }
}

@media (prefers-reduced-motion: no-preference) {
  .gc-down-panel {
    animation: gc-down-in 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  }
}

@keyframes gc-down-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}
</style>
